import { connect } from 'react-redux'
import Placement from '..'
import {
  getPlacementData,
  getPlacementStudent,
  getPreviewData,
  getTableData,
  getUserBatchHistory,
  getYear,
  updateUserBatchHistory,
  resumeBulkDownload
} from '../action'

import { getJobCategory } from '../../JobRoles/NewJobRole/actions'

import selectors from 'modules/Placement/selector'
import {
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
} from '../../JobPreview/action'

const mapStateToProps = state => ({
  instituteCampusId: state.auth.instituteDetails.id,
  tableDataAll: selectors.getTableList(state),
})

const mapDispatchToProps = {
  getPlacementData,
  getTableData,
  getUserBatchHistory,
  updateUserBatchHistory,
  getPlacementStudent,
  getYear,
  getPreviewData,
  getPlacementHistoryList,
  getStudentPlacedList,
  getJobRolePreview,
  getJobCategory,
  resumeBulkDownload
}

export default connect(mapStateToProps, mapDispatchToProps)(Placement)
